export default __webpack_public_path__ + "static/media/sidebar-icon-2.eac08b4f.svg";